import { useContext } from 'react';
import policy from '../data/policy.json';
import '../style/pages/policy.css';
import { update } from './indexDB/indexDBStora';
import { collection } from '../context/collect';
import { switchh } from '../context/switch';
export default function Policy (props) {
    const { cconfig } = useContext(collection);
    const { setLoadingProcess } = useContext(switchh);

    const acceptedPolicy = async () => {
        setLoadingProcess(true)
        const updatedConfig = {
            ...cconfig,
            isAcceptPolicy: true
        };
        
        await update("settings", updatedConfig);
        
        props.status(false);
        setLoadingProcess(false)
    };

    return (
        <div className="policy">
            <div>السياسات و الشروط</div>
            <div className='container right'>
                {policy.map((pol) => 
                <div key={pol.id} className='section'>
                    <h4>{pol.title}</h4>
                    <small>last updated: {pol.lastUpdate}</small>
                    <p>{pol.description}</p>
                    {pol && pol.sections.length !== 0 &&
                    <ol>
                        {pol.sections.map((sec, key) => 
                            <li key={key}>
                                <h5>{sec.title}</h5>
                                <small>{sec.content}</small>
                                {sec.items.length !== 0 &&
                                <ul>
                                    {sec.items.map((item, key) => 
                                    <li key={key}>{item}</li>
                                    )}
                                </ul>
                                }
                            </li>
                        )}
                    </ol>
                    }
                </div>
                )}
                <div>
                    <button className='button-zone normal-bg-v2' onClick={() => acceptedPolicy()}>الموافقة على الشروط و الأحكام</button>
                </div>
            </div>
        </div>
    )
}